"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(cells = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        this.cells = cells;
        this.restart();
    }
    moveLeft() {
        if (this.status !== "playing") return;
        let moved = false;
        for(let i = 0; i < 4; i++){
            const row = this.board[i].filter((val)=>val !== 0);
            const newRow = [];
            for(let j = 0; j < row.length; j++)if (row[j] === row[j + 1]) {
                newRow.push(row[j] * 2);
                this.score += row[j] * 2;
                j++;
                moved = true;
            } else newRow.push(row[j]);
            while(newRow.length < 4)newRow.push(0);
            if (this.board[i].toString() !== newRow.toString()) {
                this.board[i] = newRow;
                moved = true;
            }
        }
        if (moved) this.addRandomTile();
        this.checkGameOver();
    }
    moveRight() {
        if (this.status !== "playing") return;
        let moved = false;
        for(let i = 0; i < 4; i++){
            const row = this.board[i].filter((val)=>val !== 0).reverse();
            const newRow = [];
            let j = 0;
            while(j < row.length)if (row[j] === row[j + 1]) {
                newRow.push(row[j] * 2);
                this.score += row[j] * 2;
                j += 2;
                moved = true;
            } else {
                newRow.push(row[j]);
                j++;
            }
            while(newRow.length < 4)newRow.push(0);
            newRow.reverse();
            if (this.board[i].toString() !== newRow.toString()) {
                this.board[i] = newRow;
                moved = true;
            }
        }
        if (moved) this.addRandomTile();
        this.checkGameOver();
    }
    moveUp() {
        if (this.status !== "playing") return;
        let moved = false;
        for(let col = 0; col < 4; col++){
            const column = [];
            for(let row = 0; row < 4; row++)if (this.board[row][col] !== 0) column.push(this.board[row][col]);
            const newColumn = [];
            let i = 0;
            while(i < column.length)if (column[i] === column[i + 1]) {
                newColumn.push(column[i] * 2);
                this.score += column[i] * 2;
                i += 2;
            } else {
                newColumn.push(column[i]);
                i++;
            }
            while(newColumn.length < 4)newColumn.push(0);
            for(let row = 0; row < 4; row++){
                if (this.board[row][col] !== newColumn[row]) moved = true;
                this.board[row][col] = newColumn[row];
            }
        }
        if (moved) this.addRandomTile();
        this.checkGameOver();
    }
    moveDown() {
        if (this.status !== "playing") return;
        let moved = false;
        for(let col = 0; col < 4; col++){
            const column = [];
            for(let row = 0; row < 4; row++)if (this.board[row][col] !== 0) column.push(this.board[row][col]);
            const newColumn = [];
            let i = column.length - 1;
            while(i >= 0)if (column[i] === column[i - 1]) {
                newColumn.unshift(column[i] * 2);
                this.score += column[i] * 2;
                i -= 2;
                moved = true;
            } else {
                newColumn.unshift(column[i]);
                i--;
            }
            while(newColumn.length < 4)newColumn.unshift(0);
            for(let row = 0; row < 4; row++){
                if (this.board[row][col] !== newColumn[row]) moved = true;
                this.board[row][col] = newColumn[row];
            }
        }
        if (moved) this.addRandomTile();
        this.checkGameOver();
    }
    checkGameOver() {
        if (this.board.some((row)=>row.includes(2048))) this.status = "win";
        else if (!this.canMove()) this.status = "lose";
    }
    canMove() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (this.board[i][j] === 0) return true;
            if (j < 3 && this.board[i][j] === this.board[i][j + 1]) return true;
            if (i < 3 && this.board[i][j] === this.board[i + 1][j]) return true;
        }
        return false;
    }
    displayGameStatus(stat) {
        const winMessage = document.querySelector(".message-win");
        const loseMessage = document.querySelector(".message-lose");
        winMessage.classList.add("hidden");
        loseMessage.classList.add("hidden");
        if (stat === "win") winMessage.classList.remove("hidden");
        else if (stat === "lose") loseMessage.classList.remove("hidden");
        else if (stat === "playing") {
            winMessage.classList.add("hidden");
            loseMessage.classList.add("hidden");
        }
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.board.map((row)=>[
                ...row
            ]);
    }
    /**
   * Returns the current game status.
	@@ -50,19 +278,58 @@ class Game {
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    /**
   * Resets the game.
   */ restart() {
        this.board = this.cells.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = "idle";
    }
    addRandomTile() {
        const emptyCells = [];
        this.board.forEach((row, rowIndex)=>{
            row.forEach((value, colIndex)=>{
                if (value === 0) emptyCells.push({
                    rowIndex: rowIndex,
                    colIndex: colIndex
                });
            });
        });
        if (emptyCells.length > 0) {
            const randomIndex = Math.floor(Math.random() * emptyCells.length);
            const { rowIndex: rowIndex, colIndex: colIndex } = emptyCells[randomIndex];
            this.board[rowIndex][colIndex] = Math.random() < 0.9 ? 2 : 4;
            const cell = document.querySelector(`[data-position="${rowIndex}-${colIndex}"]`);
            requestAnimationFrame(()=>{
                cell.classList.add("field-cell--new");
                setTimeout(()=>{
                    cell.classList.remove("field-cell--new");
                }, 300);
            });
        }
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startButton = document.getElementById("ButtonStart");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
function $09e991522ca7e64e$var$updateBoard() {
    const state = $09e991522ca7e64e$var$game.getState();
    state.forEach((row, rowIndex)=>{
        row.forEach((value, colIndex)=>{
            const cell = document.querySelector(`[data-position="${rowIndex}-${colIndex}"]`);
            cell.textContent = value !== 0 ? value : "";
            $09e991522ca7e64e$var$updateCellClass(cell, value);
        });
    });
}
function $09e991522ca7e64e$var$updateCellClass(cell, value) {
    cell.className = "field-cell";
    if (value !== 0) cell.classList.add(`field-cell--${value}`);
}
function $09e991522ca7e64e$var$updateScore() {
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$updateMessages() {
    // eslint-disable-next-line no-shadow
    const status = $09e991522ca7e64e$var$game.getStatus();
    if (status === "win") {
        $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    } else if (status === "lose") {
        $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    } else if (status === "idle") {
        $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    } else {
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    }
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$startButton.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$updateBoard();
        $09e991522ca7e64e$var$updateMessages();
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$updateBoard();
        $09e991522ca7e64e$var$updateScore();
        $09e991522ca7e64e$var$updateMessages();
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
        $09e991522ca7e64e$var$startButton.classList.add("start");
        $09e991522ca7e64e$var$startButton.textContent = "Start";
    }
});
// eslint-disable-next-line no-shadow
window.addEventListener("keydown", (event)=>{
    switch(event.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$updateScore();
    $09e991522ca7e64e$var$updateMessages();
});


//# sourceMappingURL=index.479db672.js.map
